import type { Hole, SimulatorDto } from "Models";
import { useFacilityCourses } from "modules/course/courseHooks";
import { useFormContext } from "react-hook-form";
import type { RootState } from "StoreTypes";
import { useSelector } from "react-redux";
import CourseAndHolesForm from "components/shared/control/CourseAndHolesForm";
import { useGetCurrentLocalFacilityId } from "modules/facility/facilityHooks";
import { getSimulatorsByIdArray } from "modules/simulator/simulatorSelectors";
import MissingSimsList from "./MissingSimsList";

const FacilityCourseAndHoles: React.FC = () => {
  const { watch } = useFormContext();
  const watchCourses = watch("roundInfo.courseName");

  const currentFacilityId = useGetCurrentLocalFacilityId();

  const [queryCourses] = useFacilityCourses(currentFacilityId);

  const selectedCourseHoles: Hole[] = useSelector(
    (state: RootState) =>
      state.entities.courses?.courseData?.[watchCourses]?.holes || [],
  );

  const missingSimIds: string[] = useSelector(
    (state: RootState) =>
      state.entities.courses?.missingSimulatorsByCourse?.[watchCourses] || [],
  );

  const selectedCourseMissingSims: SimulatorDto[] = useSelector(
    (state: RootState) => getSimulatorsByIdArray(state, missingSimIds),
  );

  return (
    <div>
      {selectedCourseMissingSims.length ? (
        <MissingSimsList missingSimulators={selectedCourseMissingSims} />
      ) : null}
      <CourseAndHolesForm courses={queryCourses} holes={selectedCourseHoles} />
    </div>
  );
};

export default FacilityCourseAndHoles;
